import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { FilterFormModal } from 'src/app/models/form-group.model';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';


@Component({
  selector: 'fury-lead-partner-performance-details',
  templateUrl: './lead-partner-performance-details.component.html',
  styleUrls: ['./lead-partner-performance-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class LeadPartnerPerformanceDetailsComponent implements OnInit {
  leadPartnerId !: any;
  performanceDetails: any;
  loader !:boolean;
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:string = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
  endDate:string = moment(this.today).format('YYYY-MM-DD HH:mm:ss');
  campaignOne = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  campaignTwo = new FormGroup({
    start: new FormControl(new Date(this.year, this.month, 15)),
    end: new FormControl(new Date(this.year, this.month, 19)),
  });
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    {name: 'Created At', property: 'createdAt', visible: true},
    {name: 'Browser Info', property: 'browserInfo', visible: true},
    {name: 'Os Info', property: 'osInfo', visible: true},
    {name: 'Ip Address', property: 'ipAddress', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'Country', property: 'country', visible: true},
    {name: 'Utm Source', property: 'utmSource', visible: true},
    {name: 'Internal Url', property: 'internalUrl', visible: true},
    {name: 'Referral Url', property: 'referralUrl', visible: true},
  ];

  leadColumns = [
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Email Address', property: 'emailAddress', visible: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'Sold Amount', property: 'soldAmount', visible: true},
    {name: 'Attempts', property: 'attempts', visible: true},
    {name: 'Address', property: 'address', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'Zip', property: 'zip', visible: true},
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  tabName: string = 'totalLeads';
  leadList: any;
  listDetails !: any;
  searchBy: string = 'firstName';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  constructor(
    private apiservice: ApiService,
    private activatedRoute: ActivatedRoute,
    private router : Router,
    private cdr: ChangeDetectorRef,
    public commonService: CommonService
  ) {
    this.activatedRoute.params.subscribe((res: any) => {
      this.leadPartnerId = res?.id;
      if(this.leadPartnerId){
        this.getLeadPartnerPerformanceDetails();
        // this.getPartnerTabData();
      }
   });
   this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.tabName = res.tabName ? res.tabName : 'totalLeads';
      if(this.tabName === 'uniqueClicks'){
        this.searchBy = 'browserInfo';
      } else if(this.tabName === 'totalClicks'){
        this.searchBy = 'browserInfo';
      } else {
        this.searchBy = 'firstName';
      }
      this.getPartnerTabData();
    });
  }

  ngOnInit(): void {
  }
  getLeadPartnerPerformanceDetails(){
    this.loader = true;
    this.apiservice.get(`admin/lead-partner/get-lead-partner-particular-performance/${this.leadPartnerId}?startDate=${this.startDate}&endDate=${this.endDate}`).subscribe((res : any)=>{
      if(res?.body){
        this.loader = false;
        this.performanceDetails = res.body;
      }
    }, err =>{
      this.loader = false;
    })
  }
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getLeadPartnerPerformanceDetails();
    this.getPartnerTabData();
  };

  getPartnerTabData(){
    this.apiservice.get(`admin/lead-partner/get-lead-partner-particular-tab-performance/${this.leadPartnerId}?page=${Number(this.pageIndex) + 1
    }&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
    }&startDate=${this.startDate}&endDate=${this.endDate}&tabName=${this.tabName}&searchBy=${this.searchBy}&searchType=${this.searchType}`).subscribe((res: any)=>{
      this.listDetails = res?.body;
     if(res?.body?.analyticData){
          this.itemList = res?.body?.analyticData?.data;
          this.totalCount = res?.body?.analyticData.total;
          this.dataSource = new MatTableDataSource(this.itemList);
          this.cdr.detectChanges();
     }  else {
      this.itemList = [];
    }

    if(res?.body?.leadData){
      this.leadList = res?.body?.leadData?.data;
      this.totalCount = res?.body?.leadData.total;
      this.cdr.detectChanges();
 }  else {
  this.leadList = [];
  }
      
    })
  };

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  };
  get leadVisibleColumns() {
    return this.leadColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  };
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getPartnerTabData();
  };
  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.getPartnerTabData();
  }

  changeTabName(tabName: string){
    this.tabName = tabName;
    this.router.navigateByUrl(`/lead-partners/lead-partner-performance-details/${this.leadPartnerId}?tabName=${this.tabName}`);
    this.searchedKeyword = '';
  }

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: any[] = [
    {title: 'First Name', value: 'firstName'},
    {title: 'Last Name', value: 'lastName'},
    {title: 'Source', value: 'source'},
    // {title: 'Verified Name', value: 'verifiedName'},
    {title: 'Email Address', value: 'emailAddress'},
    // {title: 'Mobile Number', value: 'mobileNumber'},
    {title: 'Address', value: 'address'},
    {title: 'City', value: 'city'},
    // {title: 'State', value: 'state'},
    {title: 'Zip', value: 'zip'},
  ];
  
  analyticsSerchByValue: any[] = [
    {title: 'Browser Info', value: 'browserInfo'},
    {title: 'Os Info', value: 'osInfo'},
    {title: 'Ip Address', value: 'ipAddress'},
    {title: 'Email Address', value: 'emailAddress'},
    {title: 'City', value: 'city'},
    {title: 'Country', value: 'country'},
    {title: 'Utm Source', value: 'utmSource'},
    {title: 'Internal Url', value: 'internalUrl'},
    {title: 'ReferralUrl', value: 'referralUrl'},
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.isShowFilter = false;
    this.getPartnerTabData();
  }

}
